import styled from 'styled-components';

import {
  spaceL,
  spaceM,
  spaceXL,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';
import { Headline as InnerHeadline } from '@xing-com/typography';

import InnerBaseButton from '../base-button';

export const Headline = styled(InnerHeadline)<$TSFixMe>`
  margin-top: ${spaceXL};
  margin-bottom: ${spaceL};
  @media (min-width: 740px) {
    margin-top: 0;
    margin-bottom: ${spaceXL};
  }
`;

export const MobileBanner = styled.div`
  width: 100%;
  padding: ${spaceL} ${spaceXL};
  background-color: ${xdlColorBackgroundTertiary};
  @media (min-width: 740px) {
    display: none;
  }
`;

export const ButtonsContainer = styled.div`
  display: none;
  margin: ${spaceL};
  justify-content: flex-end;
  &.backToCompanies {
    justify-content: space-between;
    align-items: center;
  }

  @media (min-width: 740px) {
    display: flex;
    margin: ${spaceL} calc(-1 * ${spaceL});
  }
`;

export const BaseButton = styled(InnerBaseButton)`
  margin-left: ${spaceM};
  display: none;
  &.createProfileButton {
    display: flex;
  }
  @media (min-width: 740px) {
    display: flex;
  }
`;
